import { render, staticRenderFns } from "./date-picker.component.vue?vue&type=template&id=5fb22c96&scoped=true"
import script from "./date-picker.component.vue?vue&type=script&lang=ts"
export * from "./date-picker.component.vue?vue&type=script&lang=ts"
import style0 from "./date-picker.component.vue?vue&type=style&index=0&id=5fb22c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb22c96",
  null
  
)

export default component.exports